<template>
  <div class="history-container">
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="1100px"
      :close-on-click-modal="false"
      :before-close="handleClose"
      class="historyDialog"
    >
      <div class="history-content">

        <myTable
          class="myTable"
          :is-show-border="false"
          :table-data="tableData"
          :table-columns="columns"
          :table-loading="loading"
        >
          <el-table-column slot="handler" label="处理人" width="100">
            <template slot-scope="{row}">
              <span class="handler">{{ row.handlePeople|| '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column slot="status" label="处理状态" width="100">
            <template slot-scope="{ row }">
              <div v-if="row.statusName" class="status-box">
                <span :class="`deal-dot deal-dot-${row.status}`" /><span class="text">{{ row.statusName }}</span>
              </div>
              <span v-else>
                --
              </span>
            </template>
          </el-table-column>
          <el-table-column slot="remark" label="备注/意见" width="160" :show-overflow-tooltip="true">
            <template slot-scope="{ row }">
              <span v-html="row.remark || '--'" />
            </template>
          </el-table-column>
          <el-table-column slot="file" label="附件" width="150">
            <template slot-scope="{row}" class="attachment">
              <div class="fileList">
                <el-button v-for="(item,index) in row.attachmentsList" :key="index" size="small" type="text" @click="handlePreview(item)">{{ item.fileName }}</el-button>
                <span v-if="row.attachmentsList.length===0">--</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column slot="deal" label="操作" width="120" fixed="right">
            <template slot-scope="{row}">
              <el-button v-if="row.canBeAppointed === 1" class="intevene" type="text" @click="goIntevene(row)">指派</el-button>
              <el-button v-else-if="row.canBeAppointed === 2" class="intevene" type="text" @click="stopIntevene(row)">取消指派</el-button>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </myTable>
      </div>
      <my-person ref="person" v-model="userList" :limit="1" :disabled-users="disabledUsers" :show-users="false" @submit="submit" />
    </el-dialog>
    <!-- 指定成员 -->
    <memberTreeDialog ref="memberTreeCopyRef" :enable="enable" :close-drawer="false" :is-filter="true" :disabled-users="disabledUsers" @submit="submit" />
    <!-- <imgViewer ref="imgViewer" :img-list="imgList" /> -->
    <el-dialog
      :visible.sync="cancelDialogVisible"
      width="30%"
      :before-close="closeCancelDialog"
    >
      <div slot="title"><svg-icon icon-class="info-icon" style="margin-right:12px" />提醒</div>
      <span style="padding-left:32px">确认取消指派吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmCancel">确 定</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog :visible.sync="picDialogVisible" width="90%" title="图片预览" :append-to-body="true" @close="closePreview">
      <div v-loading="preLoadding" class="img-preview">
        <img width="100%" style="margin:0px auto;display:block;" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { appointTask, cancelAppointTask /* getDisabledUsers */ } from '@/api/process/monitoring.js'
// import imgViewer from '@/components/ImgViewer'
export default {
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    tableData: {
      type: Array,
      default: () => []
    },
    isIntervene: { // 是否进行流程干预
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      // picDialogVisible: false,
      preLoadding: false,
      // dialogImageUrl: '',
      list: [],
      loading: false,
      userList: [], // 指派人员
      disabledUsers: [], // 无法选中人的ID
      limit: 1, // 可选择指派人员个数
      imgList: [],
      columns: [
        {
          label: '流程名称',
          prop: 'processName',
          minWidth: 100,
          showTooltip: true
        },
        {
          label: '节点名称',
          prop: 'nodeName',
          minWidth: 100,
          showTooltip: true
        },
        {
          label: '创建时间',
          prop: 'createTime',
          minWidth: 160,
          showTooltip: true,
          formatter: (row) => {
            return row.createTime || '--'
          }
        },
        { label: '待办人', prop: 'waitPeople', minWidth: 100, showTooltip: true, formatter: (row) => {
          return row.waitPeople || '--'
        } },
        {
          label: '处理用时',
          prop: 'durationTime',
          minWidth: 120,
          showTooltip: true, formatter: (row) => {
            return row.durationTime || '--'
          }
        },
        {
          slot: 'handler'
        },
        {
          slot: 'status'
        },
        {
          slot: 'remark'
        },
        { slot: this.isIntervene ? 'deal' : 'file' }
      ],
      cancelDialogVisible: false,
      enable: 1
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    // 限制输入框换行操作
    handleTextareaKeydown() {
      const e = window.event || arguments[0]
      if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
        e.returnValue = false
        return false
      }
    },
    async goIntevene(row) { // 指派去掉 disabled
      this.activityData = row
      // const res = await getDisabledUsers({ taskId: this.activityData.taskId })
      this.disabledUsers = [] // res.data
      this.$refs.memberTreeCopyRef.openD(this.userList)
    },
    closeCancelDialog() {
      this.cancelDialogVisible = false
    },
    confirmCancel() {
      const params = { taskId: this.activityData.taskId }
      cancelAppointTask(params).then(result => {
        this.$message.success('取消成功')
        this.cancelDialogVisible = false
        // 取消指派后刷新列表
        this.$emit('refresh')
      })
    },
    // 取消指派
    stopIntevene(row) {
      this.activityData = row
      this.cancelDialogVisible = true
    },
    openDialog(obj) {
      this.dialogVisible = true
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    async submit(val) {
      console.log('val', val)
      this.userList = val
      if (this.userList.length > 1) {
        this.$message.warning('仅支持选择一人')
      } else {
        const params = {
          taskId: this.activityData.taskId,
          appointUserId: this.userList[0].id
        }
        appointTask(params).then(res => {
          if (res.code === 200) {
            this.$message.success('指派成功')
            // 指派成功后清空选中成员
            this.userList = []
            this.$emit('refresh')
          } else {
            this.$message.error('指派失败')
            this.userList = []
          }
        }).catch(_ => {
          this.userList = []
        })
        this.$refs.memberTreeCopyRef.handleClose()
      }
    },
    // 附件预览
    // handlePreview2(file) {
    //   console.log(file)
    //   // jpg，png, gif , svg, jpeg
    //   const suffix = file.fileName.split('.')[1].toLowerCase()
    //   if (suffix === 'png' || suffix === 'jpg' || suffix === 'gif' || suffix === 'svg' || suffix === 'jpeg') {
    //     this.imgList = []
    //     this.imgList.push(file.url)
    //     this.$refs.imgViewer.show()
    //   } else {
    //     this.openFile(file)
    //   }
    // },
    closePreview() {
      this.dialogImageUrl = ''
    },
    handlePreview(file) {
      this.$fileView.openFile({ url: file.url, name: file.fileName })
      // console.log(file, 'file')
      // const arr = file.fileName.split('.')
      // file.suffix = arr[arr.length - 1].toLowerCase()
      // // 图片预览当前页面弹窗展示
      // if (file.suffix === 'png' || file.suffix === 'jpg' || file.suffix === 'jpeg' || file.suffix === 'gif') {
      //   this.dialogImageUrl = ''
      //   this.preLoadding = true
      //   this.picDialogVisible = true
      //   this.dialogImageUrl =
      //   file.code === 200 && file.response.data ? file.response.data : file.url
      //   this.preLoadding = false
      // } else {
      // // 文件预览
      //   this.openFile(file)
      // }
    },
    openFile(file) {
      const filePath = file.fileName
      const index = filePath.lastIndexOf('.')
      // 获取后缀
      const ext = filePath.substr(index + 1)
      if (ext === 'pdf') {
        window.open(file.url, file.fileName)
      } else {
        try {
          this.download(file.url, file.fileName)
        } catch (err) {
          window.open(file.url)
        }
      }
      // window.open(file.url, file.name)
    },
    download(url, filename) {
      getBlob(url, function(blob) {
        saveAs(blob, filename)
      })

      function getBlob(url, cb) {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', url, true)
        xhr.responseType = 'blob'
        xhr.onload = function() {
          if (xhr.status === 200) {
            cb(xhr.response)
          }
        }
        xhr.send()
      }

      function saveAs(blob, filename) {
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, filename)
        } else {
          var link = document.createElement('a')
          var body = document.querySelector('body')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.style.display = 'none'
          body.appendChild(link)
          link.click()
          body.removeChild(link)
          window.URL.revokeObjectURL(link.href)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import"~@/views/taskManage/css/deal-dot.scss";

.history-content {
  min-height: 400px;
  .handler {
    color: #2C51EF;
  }
}
.historyDialog{
  /deep/.el-dialog__body {
  padding: 0px;
  margin-top: 12px;
  height:600px;
  overflow: auto;
}
}
/deep/.el-button.intevene{
  text-align: left;
}
.fileList{
  /deep/.el-button{
    margin-left: 0px;
    display: block;
    padding-top: 5px;
    padding-bottom: 5px;
    span{
      display: block;
      min-width: 40px;
      text-align: left;
      overflow-wrap: break-word;
      white-space: normal;
    }
  }
}
 .img-preview{
      max-width: 100%;
      max-height: 85vh;
      overflow:scroll;
      img{
        max-width: 100%!important;
      }
    }
    .el-dialog__wrapper{
      position:fixed;
      top:-100px;
    }

</style>
